<style lang="less">
  @import (reference) '../../../less/variables.less';
  @import (less) '@spotify-internal/encore-foundation/web/tokens.css';

  .mh-message-bar {
    position: relative;
    z-index: 1;
    background: #1D75DE;
    display: flex;
    justify-content: center;
  }

  .mh-container {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: @masthead-gutter-width;
    align-items: center;
    width: 100%;

    @media (min-width: @breakpoint-mobile) {
      width: @page-width-mobile;
    }

    @media (min-width: @breakpoint-tablet) {
      width: @page-width-tablet;
    }

    @media (min-width: @breakpoint-desktop) {
      width: @page-width-desktop;
    }
  }

  .mh-html-text {
    font-family: @masthead-font-family-default;
    color: var(--solid-white-200);
    font-size: @masthead-font-size-small;

    :global(a) {
      color: var(--solid-white-200);

      /*
       * The additional styles below
       * override encore-web global
       * styles
       */
      text-decoration: underline;
    }
  }

  .mh-close {
    font-size: 18px;
    font-family: @masthead-font-family-default;
    font-weight: @masthead-font-weight-bold;
    color: var(--solid-white-200);
    padding: 0;
    margin-left: 30px;
    cursor: pointer;
    background: transparent;
    border: 0;
    flex-shrink: 0;

    &:focus {
      outline: none;
      border-bottom: 2px solid var(--solid-white-200);
      margin-bottom: -2px;
    }
  }

  .mh-screen-reader-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .mh-active-acknowledge {
    font-size: 12px;
    margin-top: 15px;
    padding: 10px 32px;
    border-radius: 500px;
    letter-spacing: 2px;
    text-transform: uppercase;
    border-width: 0;
    font-weight: @masthead-font-weight-bold;
    cursor: pointer;
    line-height: 12px;
    transition-property: background-color, box-shadow;
    transition-duration: 0.3s;

    &:active {
      background-color: #cccccc;
      box-shadow: none;
    }

    &:focus {
      outline: 0;
      background-color: #cccccc;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1) inset;
    }
  }

  .mh-active-acknowledge-label {
    flex-direction: column;
    align-items: flex-start;
  }
</style>

<script>
  import { onMount } from 'svelte';

  export let onDisplay = () => {};
  export let onAcknowledge = () => {};
  export let clickHandlers = {};
  export let messageHTML;
  export let dir;
  export let activeAcknowledgeLabel;

  let messageContainer;

  // Multi language link provided by www-masthead-api for message bar is always https://spotify.com/{locale}/
  const getAlternateLanguage = url => {
    const splitUrl = url.split('/');
    const lastPartOfUrl = splitUrl.length - 2;
    const alternateLang = splitUrl[lastPartOfUrl];
    return alternateLang;
  };

  const updateMultiLanguageLink = () => {
    const link = messageContainer.querySelector('.multi-language-link');
    if (link) {
      const messageBarUrl = link.href;
      const alternateLocale = getAlternateLanguage(messageBarUrl);
      const currentLocationUrl = window.location.href;
      const [ currentLocale ] = window.location.pathname.split('/').filter(word => word !== ''); 
      const updatedMultilanguageLink = currentLocationUrl.replace(
        `/${currentLocale}/`,
        `/${alternateLocale}/`,
      );
      link.href = updatedMultilanguageLink;
    }
  };

  onMount(() => {
    setTimeout(onDisplay, 250);
    updateMultiLanguageLink();
  });

  const handleClick = e => {
    Object.entries(clickHandlers).forEach(([selector, handler]) => {
      if (e.target === messageContainer.querySelector(selector)) {
        handler(e);
      }
    });
  };
</script>

<div class="mh-message-bar">
  <div class="mh-container" class:mh-active-acknowledge-label={activeAcknowledgeLabel}>
    <div
      class="mh-html-text"
      bind:this="{messageContainer}"
      on:click|capture="{handleClick}"
      {...(dir ? {dir} : {})}
    >
      {@html messageHTML}
    </div>
    {#if !activeAcknowledgeLabel}
    <button class="mh-close" on:click="{onAcknowledge}">
      <span aria-hidden="true">✕</span>
      <span class="mh-screen-reader-only">Close</span>
    </button>
    {:else}
    <button class="mh-active-acknowledge" on:click="{onAcknowledge}">
      {activeAcknowledgeLabel}
    </button>
    {/if}
  </div>
</div>
